import type { FaireProductEntity } from "../../entity_types/product";

export const p_vxvz83rgb6: FaireProductEntity = {
  token: "p_vxvz83rgb6",
  type: "product",
  name: "Kawai - Peacock Display Plush Toy",
  brandToken: "b_qrthtbpuwu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/077dc880b50e1e77e62a83bc026814948ce1dc87e1edfa949875ef4ad2ba01f5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2772c74a14016ace383028b21b40c139dddb2f579645dba1ddce361404e64288.jpeg",
    "https://cdn.faire.com/fastly/bbe1fbab9d13f61bdb27ab2eda57d0e128b156e24c520bdcacb0755c3a052607.jpeg",
    "https://cdn.faire.com/fastly/68589435155e2dcee6ea0cf0b82c61d654342e991c652cacb2afad698ed78c54.jpeg",
  ],
  priceDollars: 18.02,
  description:
    "Charming Design: A peacock plush toy with a majestic display, measuring 25x30 cm, featuring vibrant colors and detailed craftsmanship.\n Multi-Purpose Use: Perfect as a companion for children or as an elegant decorative piece for the home.\n Versatile Decor: Adds a touch of nature-inspired beauty to any room, suitable for both playtime and decoration.\n\nOur popular brand offers UPC-coded, retail-ready products, ensuring quality and shopping ease. Each item is crafted for excellence and ready for immediate retail. For inquiries, our responsive customer service is at your service, guaranteeing a seamless and supportive customer experience.\n",
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:45.776Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
